import { fetchAPI } from "packs/api";
require("packs/coupon_click");
import { showToast } from './notification_toast';
import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.css';

// Side panel menu toggle — registered at module load time so it always works,
// even before DOMContentLoaded and regardless of other scripts on the page.
document.addEventListener("click", (event) => {
    // .sub-menu-item: toggle its submenu-list
    let subMenuItem = event.target.closest(".sub-menu-item");
    if (subMenuItem) {
        let subMenuList = subMenuItem.querySelector(".submenu-list");
        let iconrots = subMenuItem.querySelectorAll('.iconrot');
        if (subMenuList) {
            subMenuList.classList.toggle('hidden');
            iconrots.forEach(iconrot => iconrot.classList.toggle('hidden'));
        }
    }

    // .menu-item: toggle its menu-list only when clicking outside the menu-list
    let menuItem = event.target.closest(".menu-item");
    if (menuItem) {
        let menuList = menuItem.querySelector(".menu-list");
        let arrowIcon = menuItem.querySelector(".iconrot");
        if (menuList && !menuList.contains(event.target)) {
            menuList.classList.toggle("hidden");
            if (arrowIcon) arrowIcon.classList.toggle("-rotate-90");
        }
    }
});

// Filter panel open/close helpers (used by filters.js, forum_filters.js, credit_card_offers.js)
window.openFilterPanel = function(panel, triggerEl) {
    if (!panel || !triggerEl) return;
    var triggerRect = triggerEl.getBoundingClientRect();
    var triggerCenterX = triggerRect.left + triggerRect.width / 2;
    var triggerCenterY = triggerRect.top + triggerRect.height / 2;

    // Measure panel position without flash: use visibility hidden instead of toggling filter-open
    panel.style.visibility = 'hidden';
    panel.style.pointerEvents = 'none';
    panel.style.transition = 'none';
    panel.style.transform = 'scale(1)';
    panel.style.opacity = '1';
    var panelRect = panel.getBoundingClientRect();

    // Reset to base state (scale(0), opacity 0) with transitions still disabled
    panel.style.transform = '';
    panel.style.opacity = '';
    panel.style.visibility = '';
    panel.style.pointerEvents = '';

    var originX = triggerCenterX - panelRect.left;
    var originY = triggerCenterY - panelRect.top;
    originX = Math.max(0, Math.min(originX, panelRect.width));
    originY = Math.max(0, Math.min(originY, panelRect.height));
    panel.style.transformOrigin = originX + 'px ' + originY + 'px';

    // Force browser to commit the base state before re-enabling transitions
    void panel.offsetHeight;
    panel.style.transition = '';

    // Now add filter-open so the transition animates from scale(0) to scale(1)
    panel.classList.add('filter-open');
};

window.closeFilterPanel = function(panel) {
    if (!panel) return;
    panel.classList.remove('filter-open');
};

// Check for user preference in localStorage on page load
document.addEventListener("DOMContentLoaded", () => {
    // checkThemePreference();
    let body = document.querySelector("html");
    // let savedDarkMode = getCookie("darkMode");
    let themeToggle = document.getElementById("themeToggle");
    let themeToggle2 = document.getElementById("themeToggle-2");
    let footerButton = document.getElementById("footer-show");
    let footerContent = document.getElementById("footer-content");

    // if (savedDarkMode === "true") {
    //   body.classList.add("dark");
    // }

    // Optionally, update the checkbox state based on the current theme
    if (themeToggle) {
        themeToggle.checked = body.classList.contains("dark");
    }
    if (themeToggle2) {
        themeToggle2.checked = body.classList.contains("dark");
    }

    footerButton?.addEventListener("click", () => {
        toggleFooter(false);
    });

    let sideBarMenus = document.getElementById("side-bar-menu-open");
    let sideBarClose = document.getElementById("side-bar-menu-close");
    const swipeArea = document.getElementById("side-bar-menu");
    let startX, startY, endX, endY;
    let isSwiping = false;
    const MIN_SWIPE_DISTANCE = 50;

    if (swipeArea) {
        swipeArea.addEventListener('touchstart', function (e) {
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            isSwiping = true;
        }, { passive: true });
    
        swipeArea.addEventListener('touchmove', function (e) {
            if (!isSwiping) return;
            const touch = e.touches[0];
            endX = touch.clientX;
            endY = touch.clientY;
        }, { passive: true });
    
        swipeArea.addEventListener('touchend', function (e) {
            if (!isSwiping) return;
            const diffX = endX - startX;
            const diffY = endY - startY;
    
            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > MIN_SWIPE_DISTANCE) {
                if (diffX < -150) {
                    // console.log('Swiped Left', diffX);
                    closeSidePanel();
                    isSwiping = false;
                }
            }
        }, { passive: true });
    }

    document.querySelectorAll(".resend_link").forEach(function (button) {
        button.addEventListener("click", function () {
            var login = this.dataset.login;
            var self = this;
            fetchAPI("/profile/resend_confirmation_email", "POST", { "login": login }, "json")
            .then(function (response) {
                document.getElementById("resend_email_msg").innerHTML = I18n.t("confirmation_mail_sent");
                self.style.display = "none";
            })
            .catch(function (error) {
                console.error("Request failed:", error);
            });
        });
    });    

    if (sideBarMenus) {
        sideBarMenus.addEventListener("click", openSidePanel);
        sideBarClose.addEventListener("click", closeSidePanel);
    }


    function openSidePanel() {
        document.body.style.overflow = 'hidden';
        const menu = document.getElementById("side-bar-menu");
        menu.classList.remove("hidden");
        setTimeout(() => {
            // Setting an inline style overrides the <style>-block ID rule (#side-bar-menu)
            // which has higher specificity than the Tailwind class. Clearing style.transform
            // (empty string) only removes a previously set inline style — it does NOT
            // override a stylesheet rule. So we must set a value explicitly to win.
            menu.style.transform = 'translateX(0%)';
            menu.classList.remove("-translate-x-full");
        }, 1);
    }

    function closeSidePanel() {
        isSwiping = false;
        document.body.style.overflow = 'scroll';
        const menu = document.getElementById("side-bar-menu");
        // Animate back: inline style transitions from 0% → -100%
        menu.style.transform = 'translateX(-100%)';
        menu.classList.add("-translate-x-full");
        setTimeout(() => {
            menu.classList.add("hidden");
        }, 100);
    }

    // (menu-item delegation is registered above at module load time)


    // Search
    function showSearchSection(el, displayValue) {
        if (!el) return;
        el.style.display = displayValue || "block";
        requestAnimationFrame(() => el.classList.add("visible"));
    }
    function hideSearchSection(el) {
        if (!el) return;
        el.classList.remove("visible");
        setTimeout(() => {
            if (!el.classList.contains("visible")) {
                el.style.display = "none";
            }
        }, 250);
    }

    let searchBox = document.getElementById("search-box");
    let searchBoxSuggest = document.getElementById("search-box-suggest");
    let clearSearch = document.querySelectorAll(".clear-search");
    let dealsSearch = document.getElementById("deals-search");
    let couponSearch = document.getElementById("stores-search");
    let discussionSearch = document.getElementById("discussions-search");

    let searchResultContainer = document.getElementById(
        "search-result-container"
    );
    let mostSearchedContainer = document.getElementById(
        "most-searched-container"
    );
    let noSearchesContainer = document.getElementById(
        "no-search-result-container"
    );
    let searchLoadingContainer = document.getElementById(
        "search-loading-container"
    );

    let selectedIndex = -1; // To track the selected result

    searchBox?.addEventListener("click", function (event) {
        searchBoxSuggest.classList.add("open");
        // Remove bottom border radius when dropdown is open
        searchBox.classList.remove("rounded-bradius10");
        searchBox.classList.add("rounded-t-bradius10", "rounded-b-none");
    });
    setClearEvent();
    let typingTimeout;

    // Handle Enter key separately on keyup
    searchBox?.addEventListener("keyup", function (event) {
        if (searchBox.value.length >= 3 && (event.key === 'Enter' || event.keyCode === 13)) {
            if (dealsSearch.style.display != "none" && dealsSearch.innerHTML != "") {
                window.location.href = dealsSearch.querySelector("a").href;
            } else if (discussionSearch.style.display != "none" && discussionSearch.innerHTML != ""){
                window.location.href = discussionSearch.querySelector("a").href;
            } else if (couponSearch.style.display != "none" && couponSearch.innerHTML != ""){
                window.location.href = couponSearch.querySelector("a").href;
            } else {
                window.location.href = `/search_result?keyword=${encodeURIComponent(this.value)}&search_list=deals&workflow_state=expire&search_terms=${window.appconfig.default_search_terms}&ref=most_searched&date_range=all_time&sort_type=new`
            }
        }
    });

    // Use 'input' event for reliable text change detection during fast typing
    searchBox?.addEventListener("input", function () {
        clearTimeout(typingTimeout);
        if (searchBox.value.length >= 3) {
            document.querySelector(".search-query").textContent = "'" + searchBox.value + "'";
            document.querySelector(".clear-search").classList.remove("hidden");
            // Show loading indicator while waiting for results
            hideSearchSection(mostSearchedContainer);
            hideSearchSection(searchResultContainer);
            hideSearchSection(noSearchesContainer);
            showSearchSection(searchLoadingContainer, "flex");
            typingTimeout = setTimeout(function () {
                getSearchData(searchBox.value);
            }, 200);
        } else if (searchBox.value.length === 0) {
            hideSearchSection(searchLoadingContainer);
            showSearchSection(mostSearchedContainer);
            hideSearchSection(searchResultContainer);
            hideSearchSection(noSearchesContainer);
            document.querySelector(".clear-search").classList.add("hidden");
        } else {
            hideSearchSection(searchLoadingContainer);
            showSearchSection(mostSearchedContainer);
            hideSearchSection(searchResultContainer);
            hideSearchSection(noSearchesContainer);
        }
    });

    function setClearEvent() {
        document.addEventListener("click", function(event) {
            let clearBtn = event.target.closest(".clear-search");
            // Only handle clear button that's within the global search box context (same parent as searchBox)
            if (clearBtn && searchBox && searchBoxSuggest && clearBtn.parentElement === searchBox.parentElement) {
                hideSearchSection(searchLoadingContainer);
                showSearchSection(mostSearchedContainer);
                hideSearchSection(searchResultContainer);
                hideSearchSection(noSearchesContainer);
                searchBoxSuggest.classList.add("open");
                clearBtn.classList.add("hidden");
                searchBox.value = "";
                searchBox.focus();
            }
        });
    }

    let searchResults = [];
    
    // Modify the searchBox keydown event listener
    searchBox?.addEventListener("keydown", function (event) {
        const newResults = getSearchResults(); 
        
        if (newResults.length !== searchResults.length) {
            selectedIndex = -1; 
        }
        searchResults = newResults; 

        if (searchResults.length === 0) return;
        
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
        } else if (event.key === "Enter" && selectedIndex !== -1) {
            event.preventDefault();
            const selectedAnchor = searchResults[selectedIndex];
            selectedAnchor.click();
        }
    });

    document.addEventListener("keydown", function(event) {
        if ((event.key === "ArrowDown" || event.key === "ArrowUp") && 
            searchBoxSuggest.classList.contains("open") &&
            searchResults.length > 0) {
            event.preventDefault();
            navigateResults(event);
        }
    });

    // Remove the window.addEventListener("keydown") completely as it's redundant
    
    function navigateResults(event) {
        if (searchResults.length === 0) return;
        if (event.key === "ArrowDown") {
            selectedIndex = (selectedIndex + 1) % searchResults.length;
        } else if (event.key === "ArrowUp") {
            selectedIndex = (selectedIndex - 1 + searchResults.length) % searchResults.length;
        }
        // Apply highlight to the selected item
        searchResults.forEach((anchor, index) => {
            const div = anchor.querySelector("div");
            if (div) {
                if (index === selectedIndex) {
                    div.classList.add("bg-background-light", "dark:bg-background-btn-dark", "rounded-lg", "px-2", "py-2");
                } else {
                    div.classList.remove("bg-background-light", "dark:bg-background-btn-dark", "rounded-lg", "px-2", "py-2");
                }
            }
            // Ensure no default focus outline
            anchor.classList.add("search-result");
        });
    
        // Focus without scrolling
        if (selectedIndex >= 0) {
            searchResults[selectedIndex].setAttribute("tabindex", "-1");
            searchResults[selectedIndex].focus({ preventScroll: true });
        }
    }
    
    // Get search results
    function getSearchResults() {
        return Array.from(searchResultContainer.getElementsByTagName("a"));
    }
    
    document.addEventListener("click", function (event) {
        let isClearSearch = false;
        clearSearch.forEach(function (clearElement) {
            if (event.target === clearElement || clearElement.contains(event.target)) {
                isClearSearch = true;
            }
        });
        if (searchBoxSuggest && event.target !== searchBox && event.target !== searchBoxSuggest && !isClearSearch) {
            searchBoxSuggest.classList.remove("open");
            // Restore full border radius when dropdown is closed
            if (searchBox) {
                searchBox.classList.add("rounded-bradius10");
                searchBox.classList.remove("rounded-t-bradius10", "rounded-b-none");
            }
        }
    });
    searchBox?.addEventListener("click", function (event) {
        event.stopPropagation();
    });
    searchBoxSuggest?.addEventListener("click", function (event) {
        event.stopPropagation();
    });
    // Search END

    // Scroll page to Top
    let scrollStopTimer = null;
    window.onscroll = () => {
        if (window.location.href.indexOf("admin") == -1) {
            hideFloatingButtons();
            clearTimeout(scrollStopTimer);
            scrollStopTimer = setTimeout(() => {
                scrollFunction();
            }, 300);
        }
    };
    let scrollTop = document.getElementById("scroll-top");
    if (scrollTop) {
        scrollTop.onclick = function () {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        };
    }

    document.addEventListener("click", function (event) {
        var button = event.target.closest(".submit_action");
        if (button) {
            var pathname = window.location.pathname;
            var type = button.dataset.type;
            submitPlus(pathname, type);
        }
    });    

    let commonOptions = {
        backdrop: "dynamic",
        backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]",
        closable: true,
        onHide: () => {
            let close = document.getElementById("closediv");
            let close_signup = document.getElementById("closedivsignup");
            if (close) {
                close.classList.add("hidden");
            }
            if (close_signup) {
                close_signup.classList.add("hidden");
            }
        },
        onShow: () => {
            let close = document.getElementById("closediv");
            let close_signup = document.getElementById("closedivsignup");
            if (close) {
                close.classList.remove("hidden");
            }
            if (close_signup) {
                close_signup.classList.remove("hidden");
            }
        },
        onToggle: () => {
        },
    };

    let loginModalTarget = document.getElementById("login-modal");
    let signupModalTarget = document.getElementById("signup-modal");
    let forgotPasswordTarget = document.getElementById("forgot-password-modal");

    // Login modal
    if (document.getElementById("loginmodal"))
        document.getElementById("loginmodal").addEventListener("click", openLogin);
    if (document.getElementById("closediv"))
        document.getElementById("closediv").addEventListener("click", closeLogin);
    if (document.getElementById("loginpop"))
        document.getElementById("loginpop").addEventListener("click", openLogin);

    // Signup modal
    if (document.getElementById("signupmodal"))
        document.getElementById("signupmodal").addEventListener("click", openSignup);
    if (document.getElementById("closedivsignup"))
        document.getElementById("closedivsignup").addEventListener("click", closeSignup);
    if (document.getElementById("loginpop"))
        document.getElementById("loginpop").addEventListener("click", openSignup);

    function createModal(target, options) {
        return new Modal(target, options, {
            id: target.id + "modal",
            override: true,
        });
    }

    document.querySelectorAll("#login_fm_id_modal, #password_fm_id_modal, #login_fm_id_page, #password_fm_id_page").forEach(function(element) {
        element.addEventListener("change", validateField);
        element.addEventListener("invalid", validateField);
    });

    function validateField(event) {
        var textfield = event.target;
        textfield.setCustomValidity('');
        if (!textfield.validity.valid) {
            textfield.setCustomValidity(I18n.t("mandatory_field"));
        }
    }

     //Password eye icon view JS

     let closePassEyes = document.querySelectorAll(".close-pass-eye");

     closePassEyes.forEach(function(closePassEye) {
         closePassEye.addEventListener("click", function() {
             let openPassEye = closePassEye.closest('.pass-container').querySelector(".open-pass-eye");
             openPassEye.classList.remove('hidden');
             closePassEye.classList.add('hidden');
             let passInput = document.getElementById(`password_fm_id_${closePassEye.dataset.context}`);
             if(passInput){
                passInput.type = 'text';
             }
             
             let signPassInput =  document.getElementById(`user_password_${closePassEye.dataset.context}`);
             if(signPassInput){
                signPassInput.type = 'text';
             }
           
             let signConfirmPassInput = document.getElementById(`user_password_confirmation_${closePassEye.dataset.context}`);
             if(signConfirmPassInput){
                signConfirmPassInput.type = 'text';
             }

             let resetPassInput  = document.getElementById(`user_password`);
             if(resetPassInput){
                resetPassInput.type = 'text';
             }

             let resetConfirmPassInput  = document.getElementById(`user_password_reset`);
             if(resetConfirmPassInput){
                resetConfirmPassInput.type = 'text';
             }
             
         });
     });
     
     let openPassEyes = document.querySelectorAll(".open-pass-eye");
     
     openPassEyes.forEach(function(openPassEye) {
         openPassEye.addEventListener("click", function() {
             let closePassEye = openPassEye.closest('.pass-container').querySelector(".close-pass-eye");
             openPassEye.classList.add('hidden');
             closePassEye.classList.remove('hidden');
             let passInput = document.getElementById(`password_fm_id_${openPassEye.dataset.context}`);
             if(passInput){
                passInput.type = 'password';
             }
             
             let signPassInput =  document.getElementById(`user_password_${closePassEye.dataset.context}`);
             if(signPassInput){
                signPassInput.type = 'password';
             }
         
             let signConfirmPassInput = document.getElementById(`user_password_confirmation_${closePassEye.dataset.context}`);
             if(signConfirmPassInput){
                signConfirmPassInput.type = 'password';
             }

             let resetPassInput  = document.getElementById(`user_password`);
             if(resetPassInput){
                resetPassInput.type = 'password';
             }

             let resetConfirmPassInput  = document.getElementById(`user_password_reset`);
             if(resetConfirmPassInput){
                resetConfirmPassInput.type = 'password';
             }
             
         });
     });
     
     


    window.createModal = createModal;

    // Common options for both login and signup modals

    function openLogin() {
        if (window.innerWidth < 768) {
            window.location.href = "/login";
            return;
        }
        if (signupModalTarget && !signupModalTarget.classList.contains("hidden")) {
            createModal(signupModalTarget, commonOptions).hide();
            setTimeout(() => {
                createModal(loginModalTarget, commonOptions).show();
            }, 200);
        } else if (forgotPasswordTarget && !forgotPasswordTarget.classList.contains("hidden")) {
            createModal(forgotPasswordTarget, commonOptions).hide();
            setTimeout(() => {
                createModal(loginModalTarget, commonOptions).show();
            }, 200);
        } else {
            createModal(loginModalTarget, commonOptions).show();
        }
    }

    function closeLogin() {
        createModal(loginModalTarget, commonOptions).hide();
    }

    function openSignup() {
        if (window.innerWidth < 768) {
            window.location.href = "/signup";
            return;
        }
        if (loginModalTarget && !loginModalTarget.classList.contains("hidden")) {
            createModal(loginModalTarget, commonOptions).hide();
            setTimeout(() => {
                createModal(signupModalTarget, commonOptions).show();
            }, 200);
        } else {
            createModal(signupModalTarget, commonOptions).show();
        }
    }

    function closeSignup() {
        createModal(signupModalTarget, commonOptions).hide();
    }

    window.openLogin = openLogin;
    window.closeLogin = closeLogin;
    window.openSignup = openSignup;
    window.closeSignup = closeSignup;

    function forgotPasswordOpen() {
        if (loginModalTarget && !loginModalTarget.classList.contains("hidden")) {
            createModal(loginModalTarget, commonOptions).hide();
            setTimeout(() => {
                createModal(forgotPasswordTarget, commonOptions).show();
            }, 200);
        } else {
            createModal(forgotPasswordTarget, commonOptions).show();
        }
    }

    window.forgotPasswordOpen = forgotPasswordOpen;

    function getSearchData(query) {
        fetchAPI("/searches", "GET", {keyword: query}, "json").then(response => {
            hideSearchSection(searchLoadingContainer);
            const isEmpty = (key) => !response[key] || response[key].length === 0;
            if (["groups", "stores", "deals", "discussions"].every(isEmpty)) {
                showSearchSection(noSearchesContainer);
                hideSearchSection(searchResultContainer);
                hideSearchSection(mostSearchedContainer);
            } else {
                hideSearchSection(mostSearchedContainer);
                hideSearchSection(noSearchesContainer);
                showSearchSection(searchResultContainer);
                populateSearchData(response);
            }
            hideSearchSection(mostSearchedContainer);
        })
    }

    let emailInputForgotPass = document.getElementById('email-input');
    let submitBtn = document.getElementById('submit-btn');

    emailInputForgotPass?.addEventListener('input', function() {
        if (emailInputForgotPass.value.trim() !== '') {
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
        submitBtn.classList.remove('cursor-not-allowed');
        submitBtn.classList.add('cursor-pointer');
        } else {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.3';
        submitBtn.classList.add('cursor-not-allowed');
        }
    });

    // Signup Form validations
    let form = document.getElementById("email-form");
    let emailInput = document.getElementById("signup-email");
    let emailError = document.getElementById("email-error");

    // Function to validate email input
    function validateEmail() {
        if (!emailInput.checkValidity()) {
            // Show error message if the email is invalid
            emailError.classList.remove("hidden");
        } else {
            // Hide error message if the email is valid
            emailError.classList.add("hidden");
        }
    }

    // Attach event listeners to the email input
    if (emailInput) emailInput.addEventListener("input", validateEmail);
    if (emailInput) emailInput.addEventListener("blur", validateEmail);

    let usernameInput = document.getElementById("signup-username");
    let usernameError = document.getElementById("username-error");

    // Define validation rules for the username input
    function validateUsername() {
        // Check if the input is within the specified length range
        let minLength = 3;
        let maxLength = 16;
        let username = usernameInput.value;

        // Validation logic for username length
        if (username.length < minLength || username.length > maxLength) {
            // Show error message if the username is invalid
            usernameError.classList.remove("hidden");
        } else {
            // Hide error message if the username is valid
            usernameError.classList.add("hidden");
        }
    }

    // Attach event listeners to the username input
    if (usernameInput) usernameInput.addEventListener("input", validateUsername);
    if (usernameInput) usernameInput.addEventListener("blur", validateUsername);

    let passwordInput = document.getElementById("signup-password");
    let passwordError = document.getElementById("password-error");

    // Function to validate password input
    function validatePassword() {
        // Check if the password meets the required pattern
        if (!passwordInput.checkValidity()) {
            // Show error message if the password is invalid
            passwordError.classList.remove("hidden");
        } else {
            // Hide error message if the password is valid
            passwordError.classList.add("hidden");
        }
    }

    // Attach event listeners to the password input
    if (passwordInput) passwordInput.addEventListener("input", validatePassword);
    if (passwordInput) passwordInput.addEventListener("blur", validatePassword);


    function fadeOut(element) {
        var opacity = 1;
        var fadeEffect = setInterval(function () {
            if (opacity <= 0.1) {
                clearInterval(fadeEffect);
                element.style.display = "none";
            } else {
                element.style.opacity = opacity;
                opacity -= 0.1;
            }
        }, 50);
    }

    function showCopiedAnimation(copyIcon) {
        if (copyIcon.classList.contains('copied-busy')) return;
        copyIcon.classList.add('copied-busy');

        // Float "Copied" text upward — append to parent (HTML element), not SVG
        var wrapper = copyIcon.parentElement;
        var floater = document.createElement('span');
        floater.className = 'copied-float-text';
        floater.textContent = copyIcon.getAttribute('data-copied-text') || 'Copied!';
        var iconRect = copyIcon.getBoundingClientRect();
        var wrapperRect = wrapper.getBoundingClientRect();
        floater.style.left = (iconRect.left - wrapperRect.left + iconRect.width / 2) + 'px';
        wrapper.appendChild(floater);
        floater.addEventListener('animationend', function () {
            floater.remove();
        });

        // Hide the <use> and insert a tick <polyline> directly inside the same SVG
        var originalUse = copyIcon.querySelector('use');
        if (originalUse) originalUse.style.display = 'none';

        var tickSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        tickSvg.setAttribute('viewBox', '0 0 24 24');
        tickSvg.setAttribute('width', '100%');
        tickSvg.setAttribute('height', '100%');
        tickSvg.setAttribute('class', 'copied-tick-icon');
        var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        polyline.setAttribute('points', '4 12 10 18 20 6');
        tickSvg.appendChild(polyline);
        copyIcon.appendChild(tickSvg);

        // Revert after delay
        setTimeout(function () {
            tickSvg.classList.add('copied-reverting');
            tickSvg.addEventListener('animationend', function () {
                tickSvg.remove();
                if (originalUse) {
                    originalUse.style.display = '';
                    originalUse.classList.add('copied-returning');
                    originalUse.addEventListener('animationend', function handler() {
                        originalUse.classList.remove('copied-returning');
                        copyIcon.classList.remove('copied-busy');
                        originalUse.removeEventListener('animationend', handler);
                    });
                } else {
                    copyIcon.classList.remove('copied-busy');
                }
            });
        }, 1700);
    }
    window.showCopiedAnimation = showCopiedAnimation;

    function couponCodeCopy(){
        let couponCodes = document.querySelectorAll(".coupon-code-copy");
        couponCodes.forEach(coupon => {
            coupon.addEventListener("click", function () {
                let textToCopy = this.nextElementSibling.innerText;
                navigator.clipboard
                    .writeText(textToCopy)
                    .then(() => {
                        showCopiedAnimation(this);
                    })
                    .catch((err) => {
                        console.error("Unable to copy text: ", err);
                    });
            })
        })
    }
    window.couponCodeCopy = couponCodeCopy;

    couponCodeCopy();

    let dealPromoCardClose = document.querySelector(".close-best-deal-promo-card");
    if (dealPromoCardClose) {
        dealPromoCardClose.addEventListener("click", function () {
            this.parentNode.remove();
        })
    }


    // Notification drawer js — fully self-contained, ONE animation mechanism.
    //
    // The panel slides via its OWN `transition: transform` (toggling the `translate-x-full`
    // class on #notification-drawer); the backdrop fades via its own opacity animation on a
    // separate element. It deliberately does NOT use Flowbite's `Drawer`: Flowbite's globally
    // patched show/hide (further down this file) layered a keyframe animation on top of
    // Flowbite's own class-toggle transition, and the two raced — double slide-in in Safari,
    // instant-open in Chrome, backdrop flash, etc. With Flowbite out of this path there is
    // exactly one thing animating each property, so behaviour is identical across browsers.
    let notificationFetching = false;
    const NOTIF_ANIM_MS = 300;

    function closeNotificationDrawer() {
        const targetEl = document.getElementById('notification-drawer');
        const backdrop = document.querySelector('[notification-backdrop]');
        document.body.classList.remove('overflow-hidden');
        if (targetEl) {
            delete targetEl.dataset.open;
            targetEl.classList.add('translate-x-full'); // slide out (its own transition)
        }
        if (backdrop) {
            backdrop.classList.remove('backdrop-animate-in');
            backdrop.classList.add('backdrop-animate-out'); // fade out
        }
        setTimeout(() => {
            targetEl?.remove();
            backdrop?.remove();
        }, NOTIF_ANIM_MS);
    }

    function openNotificationDrawer() {
        const targetEl = document.getElementById('notification-drawer');
        if (!targetEl) return;

        // Backdrop: own element, own fade-in. Created fresh; click to dismiss.
        const backdrop = document.createElement('div');
        backdrop.setAttribute('notification-backdrop', '');
        backdrop.className = 'fixed inset-0 z-[500] bg-gray-900/50 dark:bg-gray-900/80 backdrop-animate-in';
        backdrop.addEventListener('click', closeNotificationDrawer);
        document.body.appendChild(backdrop);
        document.body.classList.add('overflow-hidden');

        // Slide in: the element is inserted off-screen (translate-x-full). Commit that
        // position with a reflow, then remove the class — its `transition: transform`
        // animates 100% -> 0. This is the single source of the slide animation.
        void targetEl.offsetHeight;
        targetEl.classList.remove('translate-x-full');
        targetEl.dataset.open = 'true';

        targetEl.querySelectorAll('.close-drawer').forEach((btn) => {
            btn.addEventListener('click', closeNotificationDrawer);
        });
    }

    document.querySelectorAll('.notification-side-drawer').forEach(notification => {
        notification.addEventListener('click', function () {
            if (notification.dataset.loggedIn == 'false') {
                openLogin();
                return;
            }
            if (window.location.pathname === '/notifications') {
                return;
            }

            // Toggle: if already open, close it.
            const existing = document.getElementById('notification-drawer');
            if (existing && existing.dataset.open === 'true') {
                closeNotificationDrawer();
                return;
            }
            // Stale / mid-close leftover — clean up before re-fetching.
            existing?.remove();
            document.querySelector('[notification-backdrop]')?.remove();

            if (notificationFetching) return;
            notificationFetching = true;

            fetchAPI("/notification-drawer", "GET", {}, "script").then(() => {
                openNotificationDrawer();
            }).catch(() => {
                window.location.href = '/notifications';
            }).finally(() => {
                notificationFetching = false;
            });
        });
    });

    // Close on Escape.
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            const open = document.getElementById('notification-drawer');
            if (open && open.dataset.open === 'true') closeNotificationDrawer();
        }
    });

    // app one link to download app on appstore and playstore depending on the device
    var link = document.getElementById('appDownloadLink');
    if (window.innerWidth < 768 && link) {
      var appDownloadMeta = document.getElementById('appDownloadLinkUrl');
      var appDownloadUrl = appDownloadMeta ? appDownloadMeta.getAttribute('content') : '';
      if (appDownloadUrl) {
        link.setAttribute('href', appDownloadUrl);
      }
    }

    // Checking total deal alerts count
    document.addEventListener('click', function(event) {
        const dealAlert = event.target.closest('.deal_alerts_chips');
        if (!dealAlert) return;
        const dealAlertFormContent = document.getElementById('deal-alert-form-content');
        if (dealAlertFormContent && parseInt(dealAlertFormContent.dataset.totalCount) > 30) {
            showToast(dealAlertFormContent.dataset.error);
            return;
        }
        if (dealAlert.dataset.loggedIn == 'false') {
            openLogin();
            return;
        }
        var textValue;
        if (dealAlert.querySelector('span')) {
            textValue = dealAlert.querySelector('span').textContent.trim();
        } else {
            textValue = getQueryParam("keyword");
        }
        if (textValue) {
            localStorage.setItem('chips', textValue);
        }
        let localValue = localStorage.getItem('chips');
        fetchAPI("/deal-alert", "GET", { prefill_value: localValue }, "script");
    });

    function getQueryParam(paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(paramName);
    }

    initializeTwitterWidgets();
});

function getInfoIconPath() {
  const el = document.getElementById('info-icon-path');
  return el?.dataset.infoIcon || '';
}

function createOrderCard(order) {
  const status = order.status;
  const tagClass = status === 'confirmed' ? 'text-highlight-green' : 'text-primary';
  const statusLabel = status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  const tooltipAttrs = status === 'rejected' ? `data-tooltip="${order.status_reason}" data-tooltip-position="top" style="position:absolute;"` : '';

  const brands = (order.brands || []).join(', ');
  const totalValue = order.total_value || '';
  const gcRequestId = order.gc_request_id || '';
  const createdAt = order.created_at || '';

  const infoIcon = status === 'rejected'
    ? `<svg width="18px" height="18px" class="ml-2">
            <use xlink:href="${getInfoIconPath()}"></use>
        </svg>`
    : '';

  const card = document.createElement('div');
  card.className = 'relative md:w-[927px] w-[95%] mx-auto bg-white dark:bg-background-dark rounded-md border border-light-border dark:border-dark-border mt-4';

  card.innerHTML = `
    <!-- Status Tag -->
    <div class="absolute -top-3 left-4">
      <span class="inline-flex items-center text-xs ${tagClass} bg-white px-3 py-1 rounded-full border border-light-border dark:border-dark-border" ${tooltipAttrs}>
        ${statusLabel}
        ${infoIcon}
      </span>
    </div>

    <!-- Card Content -->
    <div class="p-4 pt-6 space-y-3">
      <!-- Request Info -->
      <div class="text-sm text-primary-text-light dark:text-primary-text-dark">
        <span>Request ID:</span> ${gcRequestId} | ${createdAt}
      </div>

      <!-- Divider -->
      <hr class="border-t border-light-border dark:border-dark-border" />

      <!-- Brand and Denomination -->
      <div class="flex flex-wrap text-sm text-primary-text-light dark:text-primary-text-dark gap-x-2">
        <span><span>Brand</span> : <span class="font-bold">${brands}</span></span>
        <span>|</span>
        <span><span>Denomination</span> : <span class="font-bold">${totalValue} Dimes</span></span>
      </div>
    </div>
  `;

  return card;
}

function decodeTwitterWidgets() {
    // Decode figure[data-widget-code] elements to blockquote.twitter-tweet
    const figureWidgets = document.querySelectorAll('figure[data-widget-code]');
    figureWidgets.forEach(function(figure) {
        const widgetCodeAttr = figure.getAttribute('data-widget-code');
        if (!widgetCodeAttr) return;

        try {
            const widgetCode = decodeURIComponent(widgetCodeAttr);
            if (widgetCode && widgetCode.includes('twitter-tweet')) {
                // First check if blockquote already exists inside the figure
                let blockquote = figure.querySelector('blockquote.twitter-tweet');

                if (!blockquote) {
                    // Create a temporary container to parse the HTML
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = widgetCode;
                    blockquote = tempDiv.querySelector('blockquote.twitter-tweet');
                }

                if (blockquote) {
                    // Clone the blockquote to avoid issues with parent nodes
                    const clonedBlockquote = blockquote.cloneNode(true);
                    // Replace figure with the decoded blockquote
                    figure.parentNode.replaceChild(clonedBlockquote, figure);
                }
            }
        } catch (e) {
            console.error('Error decoding Twitter widget:', e);
        }
    });
}

function initializeTwitterWidgets() {
    // First, decode any figure[data-widget-code] elements
    decodeTwitterWidgets();
    
    const hasTwitterEmbeds = document.querySelector('blockquote.twitter-tweet') || document.querySelector('figure[data-widget-code]');
    if (hasTwitterEmbeds) {
        if (!document.querySelector('script[src*="platform.twitter.com"]')) {
            const script = document.createElement('script');
            script.src = 'https://platform.twitter.com/widgets.js';
            script.charset = 'utf-8';
            script.async = true;
            script.onload = function() {
                if (window.twttr && window.twttr.widgets) {
                    window.twttr.widgets.load();
                }
            };
            document.body.appendChild(script);
        } else {
            if (window.twttr && window.twttr.widgets) {
                window.twttr.widgets.load();
            }
        }
    }
}

if (typeof document.addEventListener !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
        let shouldInitialize = false;
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) { // Element node
                    if (node.matches && (
                        node.matches('blockquote.twitter-tweet') || 
                        node.matches('figure[data-widget-code]') ||
                        node.querySelector('blockquote.twitter-tweet') ||
                        node.querySelector('figure[data-widget-code]')
                    )) {
                        shouldInitialize = true;
                    }
                }
            });
        });
        if (shouldInitialize) {
            // Decode widgets first, then initialize
            decodeTwitterWidgets();
            setTimeout(function() {
                initializeTwitterWidgets();
            }, 100);
        }
    });
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    } else {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) == 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
}

function mark_read(class_object, identifier_key) {
    fetchAPI("/mark_read_or_unread", "GET", { read: true, identifier_key: identifier_key }, "json").then((response) => {
        // Remove and add classes
        class_object.classList.remove(
            "not_read_link",
            "bg-background-light",
            "dark:bg-background-btn-dark",
            "not_read"
        );
        class_object.classList.add(
            "read_link",
            "read",
            "bg-white",
            "dark:bg-background-dark"
        );
        // Modify header element by ID
        const header = document.getElementById(`${identifier_key}_header`);
        if (header) {
            header.classList.remove(
            "bg-background-light",
            "dark:bg-background-btn-dark",
            "not_read"
            );
            header.classList.add("read", "bg-light-theme-read", "dark:bg-dark-theme-read");
        }
        // Update SVG use tag if present
        const svgUse = class_object.querySelector("svg use");
        if (svgUse) {
            svgUse.setAttribute("xlink:href", "/assets/ico_pepper.svg#read");
        }
        // Update unread counter (desktop + mobile)
        var notificationCircle = document.getElementById("notification_red_circle");
        var notificationCircleMobile = document.getElementById("notification_red_circle_mobile");
        var unreadCount = document.getElementById("unread_notification_count");
        var unreadCountMobile = document.getElementById("static_unread_notification_count");
        var formattedCount = response.unread_notification > 99 ? "99+" : response.unread_notification;
        if (response.unread_notification > 0) {
            notificationCircle?.classList.remove("hidden");
            notificationCircleMobile?.classList.remove("hidden");
            if (unreadCount) unreadCount.textContent = formattedCount;
            if (unreadCountMobile) unreadCountMobile.textContent = formattedCount;
        } else {
            notificationCircle?.classList.add("hidden");
            notificationCircleMobile?.classList.add("hidden");
        }
        // Remove onclick attribute
        class_object.removeAttribute("onclick");
    }).catch(error => {
        showToast(I18n.t("validation_api_error"));
    });
}
window.mark_read = mark_read;

// Signal other tabs when a notification was marked as read via ?nk= param (server-side)
// Cookie format: "identifier_key|unread_count"
document.addEventListener("DOMContentLoaded", function () {
    var nkCookie = document.cookie.split("; ").find(function (c) { return c.startsWith("nk_read="); });
    if (nkCookie) {
        var value = decodeURIComponent(nkCookie.split("=")[1]);
        // Signal the original tab to update its UI
        localStorage.setItem("notification_marked_read", value + "|" + Date.now());
        // Clear the short-lived cookie
        document.cookie = "nk_read=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
    // Clean up nk param from URL if present
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("nk")) {
        urlParams.delete("nk");
        var cleanUrl = window.location.pathname + (urlParams.toString() ? "?" + urlParams.toString() : "") + window.location.hash;
        window.history.replaceState({}, "", cleanUrl);
    }
});

// Listen for notification marked-as-read from other tabs and update UI
// localStorage value format: "identifier_key|unread_count|timestamp"
window.addEventListener("storage", function (e) {
    if (e.key !== "notification_marked_read" || !e.newValue) return;
    var parts = e.newValue.split("|");
    var identifierKey = parts[0];
    var unreadCount = parseInt(parts[1], 10);

    // Update notification item on /notifications page
    var item = document.getElementById(identifierKey);
    if (item) {
        item.classList.remove("bg-background-shade-light", "dark:bg-background-btn-dark", "not_read", "read_link", "bg-background-light");
        item.classList.add("read", "bg-white", "dark:bg-background-dark", "not_read_link");
        var icon = item.querySelector(".icon");
        if (icon) {
            icon.innerHTML = '<div class="w-[10px] h-[10px] bg-transparent rounded-full"></div>';
        }
        item.removeAttribute("onclick");
    }
    // Update header dropdown item
    var header = document.getElementById(identifierKey + "_header");
    if (header) {
        header.classList.remove("bg-background-light", "dark:bg-background-btn-dark", "not_read");
        header.classList.add("read", "bg-light-theme-read", "dark:bg-dark-theme-read");
    }
    // Update unread count badge (using count from server, no extra API call)
    var notificationCircle = document.getElementById("notification_red_circle");
    var notificationCircleMobile = document.getElementById("notification_red_circle_mobile");
    var unreadCountEl = document.getElementById("unread_notification_count");
    var unreadCountMobile = document.getElementById("static_unread_notification_count");
    var formattedCount = unreadCount > 99 ? "99+" : unreadCount;
    if (unreadCount > 0) {
        notificationCircle?.classList.remove("hidden");
        notificationCircleMobile?.classList.remove("hidden");
        if (unreadCountEl) unreadCountEl.textContent = formattedCount;
        if (unreadCountMobile) unreadCountMobile.textContent = formattedCount;
    } else {
        notificationCircle?.classList.add("hidden");
        notificationCircleMobile?.classList.add("hidden");
    }
});

function mark_read_or_unread_header(is_read, class_object, identifier_key) {
    if (is_read) return;
    fetchAPI("/mark_read_or_unread", "GET", { identifier_key: identifier_key }, "json").then(response => {
        var item = document.getElementById(identifier_key);
        var header = document.getElementById(identifier_key + "_header");
        item?.classList.remove("bg-background-light", "dark:bg-background-btn-dark", "not_read");
        item?.classList.add("read", "bg-light-theme-read", "dark:bg-dark-theme-read");
        header?.classList.remove("bg-background-light", "dark:bg-background-btn-dark", "not_read");
        header?.classList.add("read", "bg-light-theme-read", "dark:bg-dark-theme-read");
        var notificationCircle = document.getElementById("notification_red_circle");
        var notificationCircleMobile = document.getElementById("notification_red_circle_mobile");
        var unreadCount = document.getElementById("unread_notification_count");
        var unreadCountMobile = document.getElementById("static_unread_notification_count");
        var formattedCount = response.unread_notification > 99 ? "99+" : response.unread_notification;
        if (response.unread_notification > 0) {
            notificationCircle?.classList.remove("hidden");
            notificationCircleMobile?.classList.remove("hidden");
            if (unreadCount) unreadCount.textContent = formattedCount;
            if (unreadCountMobile) unreadCountMobile.textContent = formattedCount;
        } else {
            notificationCircle?.classList.add("hidden");
            notificationCircleMobile?.classList.add("hidden");
        }
        class_object.removeAttribute("onclick");
    }).catch(error => {
        showToast(I18n.t("validation_api_error"));
    });
}
window.mark_read_or_unread_header = mark_read_or_unread_header;

function toggleTheme() {
    let body = document.querySelector("html");
    let themeContainer = document.getElementById("themeContainer");
    let themeToggle = document.getElementById("themeToggle");
    let themeToggle2 = document.getElementById("themeToggle-2");
    
    // Apply transition class
    body.classList.add('theme-transition');
    
    // Force browser reflow so transition is registered *before* color swap
    void body.offsetHeight; 
    
    // Toggle the theme
    body.classList.toggle("dark");
    
    window.setTimeout(() => {
        body.classList.remove('theme-transition');
    }, 500);

    let newTheme;
    if (body.classList.contains("dark")) {
        newTheme = "dark";
    } else {
        newTheme = "light";
    }
    
    if (themeToggle) {
        themeToggle.checked = body.classList.contains("dark");
    }
    if (themeToggle2) {
        themeToggle2.checked = body.classList.contains("dark");
    }

    fetch('/update_default_theme', {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ theme: newTheme })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            showToast(data.message)
        }
    })
    .catch(error => {
        console.error("Error updating theme:", error);
    });
}


function openLoginToggle(toggle) {
    toggle.checked = false;
    openLogin();
}

window.openLoginToggle = openLoginToggle;

// --- Theme Color Selector (cookie-based, colors from AppConfig) ---
var THEME_COLOR_PRESETS = (window.appconfig && window.appconfig.theme_colors) || {};

function setThemeColor(colorKey) {
    var preset = THEME_COLOR_PRESETS[colorKey];
    if (!preset) return;

    var s = document.documentElement.style;
    s.setProperty('--color-primary', preset.primary);
    s.setProperty('--color-primary-rgb', preset.rgb);
    s.setProperty('--color-shade-light', preset.shadeLight);
    s.setProperty('--color-shade-dark', preset.shadeDark);
    s.setProperty('--color-chat-bubble-light', preset.chatLight);
    s.setProperty('--color-chat-bubble-dark', preset.chatDark);

    Cookies.set('theme_color', colorKey, { expires: 365, path: '/' });
    showToast(I18n.t("theme_color_updated"));

    fetch('/update_theme_color', {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ theme_color: colorKey })
    }).catch(function(error) {
        console.error("Error saving theme color:", error);
    });
}
window.setThemeColor = setThemeColor;

// function checkThemePreference() {
//     let savedDarkMode = getCookie("darkMode");
//     if (savedDarkMode === "true") {
//         if (savedDarkMode == undefined || savedDarkMode == null) {
//             setCookie("darkMode", "true", 1000);
//         }
//         let body = document.querySelector("html");
//         let themeToggle = document.getElementById("theme-toggle");
//         let themeToggle2 = document.getElementById("theme-toggle-2");

//         if (themeToggle && getComputedStyle(themeToggle).display === "none" && themeToggle2) {
//             themeToggle2.checked = body.classList.contains("dark") ? "checked" : "";
//         } else if (themeToggle) {
//             if (savedDarkMode == null || savedDarkMode == undefined) {
//                 body.classList.toggle("dark");
//             }
//             themeToggle.checked = body.classList.contains("dark") ? "checked" : "";
//         }
//     }
// }

function populateSearchData(response) {
    //<%# Populating Groups and stores with single dynamic method %>
    displayItems(response, "groups", "groups-search", "groups-search-container", "groups");
    var storeUrlPrefix = (window.appconfig && window.appconfig.store_url_prefix) || "coupons";
    displayItems(response, "stores", "stores-search", "stores-search-container", storeUrlPrefix);

    //<%# Dynamic function for Populating Groups and stores %>
    function displayItems(response, category, elementId, containerId, urlPath) {
        var element = document.getElementById(elementId);
        var container = document.getElementById(containerId);
        if (response[category] && response[category].length > 0) {
            element.style.display = "block";
            container.innerHTML = "";
            var items = "";
    
            response[category].forEach(function (value) {
                var name = category === "stores" ? value.merchant_name : value.name;
                items += `
                    <a href="/${urlPath}/${value.permalink}?ref=most_searched">
                        <div class="flex justify-between items-center mb-3">
                            <div class="flex items-center font-medium text-[15px]">
                                <div class="w-[48px] h-[48px] border border-light-border dark:border-dark-border rounded-lg mr-2 flex justify-center items-center">
                                    <img src="${value.image}" class="w-full max-w-[42px] h-auto max-h-[42px]" alt="${category} Image">
                                </div>
                                ${name}
                            </div>
                            <div>
                                <svg class="w-[24px] text-primary-text-light dark:text-primary-text-dark" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m10 16 4-4-4-4"/>
                                </svg>
                            </div>
                        </div>
                    </a>`;
            });
            container.innerHTML = items;
        } else {
            element.style.display = "none";
        }
    }
    

    // <%# Populating Deals, Discussions and Coupons with single dynamic method %>
    displayCategory(response, "deals", "deals-search", I18n.t("deals"));
    displayCategory(response, "discussions", "discussions-search", I18n.t("discussions"));
    displayCategory(response, "coupons", "coupons-search", I18n.t("coupons"));

    // <%# Dynamic function for Populating Deals, Discussions and Coupons %>
    function displayCategory(response, category, elementId, countLabel) {
        var live_count = 0;
        var sort_type = "";
        if (category === "deals") {
            live_count = response.live_deals_count;
            sort_type = "&sort_type=new";
        }
        if (category === "discussions") {
            live_count = response.live_discussions_count;
            sort_type = "&sort_type=new";
        }
        if (category === "coupons") {
            live_count = response.live_coupons_count;
        }
        var element = document.getElementById(elementId);
        if (response[category] && live_count > 0) {
            element.style.display = "block";
            element.innerHTML = `
                <a href="/search_result?keyword=${encodeURIComponent(response.keyword)}&search_list=${category}&ref=most_searched${sort_type}&workflow_state=expire&search_terms=${window.appconfig.default_search_terms}&date_range=all_time">
                    <div class="flex justify-between items-center mb-3">
                        <div class="font-medium text-[15px]">
                            '${response.keyword}' <span class="font-bold text-primary">${countLabel}(${live_count})</span>
                        </div>
                        <div>
                            <svg class="w-[24px] text-primary-text-light dark:text-primary-text-dark" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m10 16 4-4-4-4"/>
                            </svg>
                        </div>
                    </div>
                </a>`;
        } else {
            element.style.display = "none";
            element.innerHTML = "";
        }
    }    
}

function hideFloatingButtons() {
    const scrollTopBtn = document.getElementById("scroll-top");
    const footerShowBtn = document.getElementById("footer-show");
    if (scrollTopBtn) {
        scrollTopBtn.classList.add("translate-y-[calc(100%+20px)]");
        scrollTopBtn.classList.remove("translate-y-0");
    }
    if (footerShowBtn) {
        footerShowBtn.classList.add("translate-y-[calc(100%+20px)]");
        footerShowBtn.classList.remove("translate-y-0");
    }
}

function showFloatingButton(el) {
    if (el) {
        el.classList.remove("translate-y-[calc(100%+20px)]");
        el.classList.add("translate-y-0");
    }
}

function scrollFunction() {
    // Calculate half of the viewport height (first fold)
    const halfViewportHeight = window.innerHeight / 2;
    const scrolled = document.body.scrollTop || document.documentElement.scrollTop;

    // Check if footer is positioned normally (not hidden off-screen)
    const footerContent = document.getElementById("footer-content");
    const isFooterPositionedNormally = footerContent && getComputedStyle(footerContent).position === 'relative';

    // Only check visibility if footer is positioned normally
    const isFooterSignificantlyVisible = isFooterPositionedNormally && isElementMoreThanPercentInView(footerContent, 20);

    const scrollTopBtn = document.getElementById("scroll-top");
    const footerShowBtn = document.getElementById("footer-show");

    if (scrolled > halfViewportHeight) {
        showFloatingButton(scrollTopBtn);

        if (footerShowBtn) {
            // Hide footer-show button only if footer is positioned normally AND more than 20% visible
            if (isFooterSignificantlyVisible) {
                hideFloatingButtons();
            } else {
                showFloatingButton(footerShowBtn);
            }
        }
    } else {
        hideFloatingButtons();
    }

}

function isElementMoreThanPercentInView(el, percent) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const elementHeight = rect.height;
    
    // Calculate visible portion
    const visibleTop = Math.max(0, rect.top);
    const visibleBottom = Math.min(window.innerHeight, rect.bottom);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);
    
    // Check if visible height is more than the specified percentage
    return (visibleHeight / elementHeight) * 100 > percent;
}

function checkVisible(elm, visibility = "visible") {
    var element = (typeof elm === "string") ? document.querySelector(elm) : elm; // Convert selector to DOM element
    if (!element) return false; // Prevent errors if element doesn't exist
    var rect = element.getBoundingClientRect(),
        vpH = window.innerHeight, // Viewport Height
        st = window.scrollY || document.documentElement.scrollTop, // Scroll Top
        y = rect.top + st, // Element's top position relative to document
        elementHeight = rect.height;
        
    return visibility === "visible" ? (y < (vpH + st) && y > (st - elementHeight)) : false;
}

function submitPlus(path, type) {
    var url = "";
    if (type === "coupon") {
        url = "/coupons/new";
    } else if (type === "deal") {
        var dealInput = document.getElementById("forum-deal");
        url = dealInput ? "/deals/new?forum_id=" + dealInput.value : "/deals/new";
    } else if (type === "discussion") {
        var discussionInput = document.getElementById("forum-discussion");
        url = discussionInput ? "/discussions/new?forum_id=" + discussionInput.value : "/discussions/new";
    } else if (type === "feedback") {
        url = "/feedbacks/new";
    }
    
    if (url !== path) {
        window.location.href = window.location.origin + url;
    }
}

window.toggleTheme = toggleTheme;

function toggleFooter(isOpen) {
    const footerContent = document.getElementById("footer-content");
    const footerDrawerContent = document.getElementById("footer-drawer-content");
    const footerDrawer = document.getElementById("footer-drawer");
    
    // Exit if any required elements don't exist (footer drawer only exists on pages where footer is hidden)
    if (!footerContent || !footerDrawerContent || !footerDrawer) {
        return;
    }
    
    footerDrawerContent.innerHTML = footerContent.innerHTML;
    let target = footerDrawer;
    let options = {
        placement: 'bottom',
        backdrop: true,
        bodyScrolling: false,
        edge: false,
        edgeOffset: '',
        backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]',
        onHide: () => {
            const footerHideButton = document.getElementById("footer-hide");
            if (footerHideButton) {
                footerHideButton.classList.add("hidden");
            }
            footerDrawer.style.transform = "translateY(100%)";
            setTimeout(() => {
                footerDrawer.style.display = "none";
                if (footerDrawerContent) {
                    footerDrawerContent.innerHTML = "";
                }
            }, 200);
        },
        onShow: () => {
            const footerHideButton = document.getElementById("footer-hide");
            if (footerHideButton) {
                footerHideButton.classList.remove("hidden");
                footerHideButton.addEventListener("click", function () {
                    toggleFooter(true);
                });
            }
            footerDrawer.style.display = "block";
            footerDrawer.style.transform = "translateY(0%)";
        },
        onToggle: () => {},
    }
    let instanceOptions = {
        id: 'footer-drawer',
        override: true
    };
    let instance = new Drawer(target, options, instanceOptions);
    if (isOpen) {
        instance.hide();
    } else {
        instance.show();
    }
}

function fadeOut(element) {
    var opacity = 1;
    var fadeEffect = setInterval(function () {
        if (opacity <= 0.1) {
            clearInterval(fadeEffect);
            element.style.display = "none";
            element.style.opacity = 1;
        } else {
            element.style.opacity = opacity;
            opacity -= 0.1;
        }
    }, 50);
}

function slideUpContent(element) {
    element.style.height = element.scrollHeight + "px";
    element.style.opacity = 1;
    element.style.transform = "translateY(0)";
    element.offsetHeight;
    element.style.transition = "height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    element.style.height = "0px";
    element.style.opacity = 0;
    element.style.transform = "translateY(-10px)";
    setTimeout(function () {
        element.classList.add('hidden');
        element.style.height = "";
        element.style.transition = "";
        element.style.opacity = "";
        element.style.transform = "";
    }, 300);
}


function slideDownContent(element) {
    element.classList.remove('hidden');
    element.style.height = "0px";
    element.style.opacity = 0;
    element.style.transform = "translateY(-10px)";
    element.offsetHeight;
    element.style.transition = "height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    element.style.height = element.scrollHeight + "px";
    element.style.opacity = 1;
    element.style.transform = "translateY(0)";
    setTimeout(function () {
        element.style.height = "";
        element.style.transition = "";
        element.style.opacity = "";
        element.style.transform = "";
    }, 300);
}

function scrollToParentComment(str) {
    let element = document.getElementById(`post_${str}_new`)
    if (element) {
        element.scrollIntoView();
    }
}

function timerFunction(time_sec, element, callback){
    let timeLeft = time_sec;

    const timerInterval = setInterval(() => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
  
      const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        
      if(element){
        element.textContent = formattedTime;
      }
  
      timeLeft--;
  
      // Stop the timer when time is up
      if (timeLeft < 0) {
        clearInterval(timerInterval);
        
        callback();
        
      }
    }, 1000);
}
function toggleBlur(dealId, link, event) {
    event.stopPropagation();
    event.preventDefault();
    let img;
    img = link.parentNode.querySelector(`.image-${dealId}`);
    if (!img) img = document.getElementById(`image-${dealId}`);
    img.classList.toggle('content-blur');
    link.remove();
}

document.addEventListener("DOMContentLoaded", function () {
    var eventBtn = document.querySelector(".event-floating-btn");
    if (!eventBtn) return;

    var eventId = eventBtn.getAttribute("data-event-id");
    var eventCookie = getEventCookie("event_show_" + eventId);

    if (eventCookie) {
        eventBtn.remove();
    } else {
        eventBtn.style.display = "block";
    }
});

function closeEvent() {
    var eventBtn = document.querySelector(".event-floating-btn");
    if (!eventBtn) return;

    var eventId = eventBtn.getAttribute("data-event-id");
    eventBtn.style.display = "none";
    setEventCookie("event_show_" + eventId, "false", 1);
}

window.closeEvent = closeEvent;

function getEventCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}

function setEventCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
}

// Animated dropdown show — pop in with opacity + translateY + scale
function showDropdownAnimated(element) {
    if (!element) return;
    if (element._dropdownAnimationTimeout) {
        clearTimeout(element._dropdownAnimationTimeout);
        element._dropdownAnimationTimeout = null;
    }

    // Prevent stale hide/show handlers from previous rapid toggles.
    element._dropdownAnimationToken = (element._dropdownAnimationToken || 0) + 1;
    const token = element._dropdownAnimationToken;

    element.classList.remove('hidden');
    const baseTransform = getComputedStyle(element).transform;
    element.style.setProperty('--dropdown-base-transform', baseTransform === 'none' ? 'translate3d(0, 0, 0)' : baseTransform);
    element.style.willChange = 'opacity, transform';
    element.style.animation = 'none';
    void element.offsetHeight; // Force reflow so animation reliably restarts.
    element.style.animation = 'dropdown-pop-in 0.2s cubic-bezier(0.16, 1, 0.3, 1) both';
    element.addEventListener('animationend', function handler() {
        if (element._dropdownAnimationToken !== token) return;
        element.style.animation = '';
        element.style.willChange = '';
        element.style.removeProperty('--dropdown-base-transform');
        element.removeEventListener('animationend', handler);
    }, { once: true });
}

// Animated dropdown hide — pop out with opacity + translateY + scale
function hideDropdownAnimated(element, callback) {
    if (!element || element.classList.contains('hidden')) { if (callback) callback(); return; }
    if (element._dropdownAnimationTimeout) {
        clearTimeout(element._dropdownAnimationTimeout);
        element._dropdownAnimationTimeout = null;
    }

    element._dropdownAnimationToken = (element._dropdownAnimationToken || 0) + 1;
    const token = element._dropdownAnimationToken;

    let done = false;
    const finish = () => {
        if (done || element._dropdownAnimationToken !== token) return;
        done = true;
        element.classList.add('hidden');
        element.style.animation = '';
        element.style.willChange = '';
        element.style.removeProperty('--dropdown-base-transform');
        element._dropdownAnimationTimeout = null;
        if (callback) callback();
    };

    const baseTransform = getComputedStyle(element).transform;
    element.style.setProperty('--dropdown-base-transform', baseTransform === 'none' ? 'translate3d(0, 0, 0)' : baseTransform);
    element.style.willChange = 'opacity, transform';
    element.style.animation = 'none';
    void element.offsetHeight; // Force reflow so animation reliably restarts.
    element.style.animation = 'dropdown-pop-out 0.15s ease-in both';
    element.addEventListener('animationend', finish, { once: true });

    // Fallback in case animationend doesn't fire
    element._dropdownAnimationTimeout = setTimeout(finish, 180);
}

window.toggleBlur = toggleBlur;
window.timerFunction = timerFunction;
window.fadeOut = fadeOut;
window.slideUpContent = slideUpContent;
window.slideDownContent = slideDownContent;
window.showDropdownAnimated = showDropdownAnimated;
window.hideDropdownAnimated = hideDropdownAnimated;
window.scrollToParentComment = scrollToParentComment;

// Drag to scroll functionality - using event delegation for dynamic content
(function() {
    let dragState = { el: null, isDown: false, startX: 0, scrollLeft: 0 };
    let wasDragged = false;
    
    document.addEventListener('mousedown', e => {
        const el = e.target.closest('[data-drag-scroll]');
        if (!el) return;
        
        // Prevent image/text drag behavior
        e.preventDefault();
        
        wasDragged = false;
        dragState = { el, isDown: true, startX: e.clientX, scrollLeft: el.scrollLeft };
        el.style.cursor = 'grabbing';
    });
    
    document.addEventListener('mousemove', e => {
        if (!dragState.isDown || !dragState.el) return;
        e.preventDefault();
        const dx = e.clientX - dragState.startX;
        if (Math.abs(dx) > 5) wasDragged = true;
        dragState.el.scrollLeft = dragState.scrollLeft - dx;
    });
    
    document.addEventListener('mouseup', () => {
        if (dragState.el) {
            dragState.el.style.cursor = 'grab';
        }
        dragState = { el: null, isDown: false, startX: 0, scrollLeft: 0 };
    });
    
    // Block link clicks only if user dragged
    document.addEventListener('click', e => {
        const link = e.target.closest('[data-drag-scroll] a');
        if (link && wasDragged) {
            e.preventDefault();
            e.stopPropagation();
            wasDragged = false;
        }
    }, true);
})();

// Add Flowbite Animations globally for Modal and Drawer
document.addEventListener("DOMContentLoaded", function() {
    if (window.Modal) {
        const originalModalShow = window.Modal.prototype.show;
        const originalModalHide = window.Modal.prototype.hide;

        window.Modal.prototype.show = function() {
            if (this._targetEl) {
                this._targetEl.classList.remove('modal-animate-out');
                this._targetEl.classList.add('modal-animate-in');
            }
            originalModalShow.apply(this, arguments);
            setTimeout(() => {
                const backdrop = document.querySelector('[modal-backdrop]');
                if (backdrop) {
                    backdrop.classList.remove('backdrop-animate-out');
                    backdrop.classList.add('backdrop-animate-in');
                }
            }, 10);
        };

        window.Modal.prototype.hide = function() {
            if (this._isHiding || (this._targetEl && this._targetEl.classList.contains('hidden'))) return;
            this._isHiding = true;
            
            if (this._targetEl) {
                this._targetEl.classList.remove('modal-animate-in');
                this._targetEl.classList.add('modal-animate-out');
            }
            const backdrop = document.querySelector('[modal-backdrop]');
            if (backdrop) {
                backdrop.classList.remove('backdrop-animate-in');
                backdrop.classList.add('backdrop-animate-out');
            }
            
            setTimeout(() => {
                originalModalHide.apply(this, arguments);
                this._isHiding = false;
            }, 180); 
        };
    }

    if (window.Drawer) {
        const originalDrawerShow = window.Drawer.prototype.show;
        const originalDrawerHide = window.Drawer.prototype.hide;

        window.Drawer.prototype.show = function() {
            if (this._targetEl) {
                this._targetEl.style.display = "block";
                void this._targetEl.offsetHeight; 
                
                if (this._options && this._options.placement === 'bottom') {
                    this._targetEl.classList.remove('drawer-animate-out-bottom');
                    this._targetEl.classList.add('drawer-animate-in-bottom');
                }
            }
            originalDrawerShow.apply(this, arguments);

            // Flowbite creates the backdrop synchronously at FULL opacity. Apply the
            // fade-in class in the SAME frame (no setTimeout) so the backdrop never
            // paints a full-opacity frame before opacity:0 — that gap was the grey flash.
            const backdrop = document.querySelector('[drawer-backdrop]');
            if (backdrop) {
                backdrop.classList.remove('backdrop-animate-out');
                backdrop.classList.add('backdrop-animate-in');
            }
        };

        window.Drawer.prototype.hide = function() {
            if (this._isHiding || (this._targetEl && this._targetEl.classList.contains('hidden'))) return;
            this._isHiding = true;

            if (this._targetEl) {
                if (this._options && this._options.placement === 'bottom') {
                    this._targetEl.classList.remove('drawer-animate-in-bottom');
                    this._targetEl.classList.add('drawer-animate-out-bottom');
                }
            }
            const backdrop = document.querySelector('[drawer-backdrop]');
            if (backdrop) {
                backdrop.classList.remove('backdrop-animate-in');
                backdrop.classList.add('backdrop-animate-out');
            }
            
            setTimeout(() => {
                originalDrawerHide.apply(this, arguments);
                this._isHiding = false;
            }, 250); 
        };
    }
});
